import IconChevronDown from '@eduzz/houston-icons/ChevronDown';
import IconChevronUp from '@eduzz/houston-icons/ChevronUp';
import Download from '@eduzz/houston-icons/Download';
import { Box, Button, Collapse, Grid, Typography } from '@material-ui/core';
import { makeStyles } from '@material-ui/core';
import { CourseTheme } from 'assets/themes/Course';
import { IDownload } from 'interface/filedownload';
import React, { useState } from 'react';
import { API_V4_BASE_URL } from 'settings';

interface IProps {
  list: IDownload[];
}

const useStyles = makeStyles<CourseTheme>((theme) => ({
  iconList: {
    display: 'flex',
    '& > p': {
      color: theme.variables.courseTheme.text,
      marginLeft: 10,
      fontSize: 14,
    },
    '& > span': {
      color: theme.variables.courseTheme.text,
      marginBottom: 20,
    },
  },
  title: {
    fontSize: 24,
    color: theme.variables.courseTheme.text,
    marginBottom: 30,
    fontWeight: 700,
  },
  buttonText: {
    display: 'block',
    color: theme.variables.courseTheme.text,
    fontWeight: 600,
    textTransform: 'lowercase',
    '&:first-letter': {
      textTransform: 'uppercase',
    },
  },
  expandContainer: {
    cursor: 'pointer',
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    '& svg': {
      marginTop: theme.spacing(1),
      color: theme.variables.courseTheme.text,
    },
  },
  listDownloadContainer: {
    marginTop: theme.spacing(8),
    [theme.breakpoints.down('md')]: {
      padding: '30px 20px',
    },
  },
}));

const ListDownload = ({ list }: IProps) => {
  const classes = useStyles({});
  const [expanded, setExpanded] = useState(false);
  const listLength = list.length;

  const handleExpand = () => setExpanded((prev) => !prev);

  if (!listLength) return null;

  return (
    <Grid aria-label='Lista de arquivos da aula' id='files' className={classes.listDownloadContainer}>
      <Typography className={classes.title}>Arquivos desta aula</Typography>
      <Collapse in={expanded} collapsedSize={160}>
        <ul>
          {list.map((item, index) => (
            <a
              aria-label='Link para baixar o arquivo'
              href={`${API_V4_BASE_URL}${item.file_name}`}
              target='_blank'
              rel='noreferrer'
              id='lesson-files-list'
            >
              <li key={index} className={classes.iconList}>
                <Download />
                <Typography aria-label='título do arquivo'>{item.title}</Typography>
              </li>
            </a>
          ))}
        </ul>
      </Collapse>
      {listLength > 4 && (
        <Button
          fullWidth
          aria-label='Botão visualizar todos os arquivos da aula'
          className={classes.expandContainer}
          variant='text'
          onClick={handleExpand}
        >
          <Typography variant='body2' className={classes.buttonText}>
            Ver todos os arquivos
          </Typography>
          <Box marginLeft={3}>{expanded ? <IconChevronUp /> : <IconChevronDown />}</Box>
        </Button>
      )}
    </Grid>
  );
};
export default ListDownload;
